import api_base from "@/api/base";

export interface Notification {
  id: string;
  title: string;
  message: string;
  notification_type: string;
  related_object_id: string | null;
  is_read: boolean;
  created_at: number;
}

export interface NotificationListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Notification[];
}

export interface NotificationParams {
  page?: number;
  ordering?: string;
}

export const getNotifications = async (params?: NotificationParams): Promise<NotificationListResponse> => {
  const response = await api_base.get("/api/v1/notifications/", { params });
  return response.data;
};

export const markAsRead = async (id: string): Promise<Notification> => {
  const response = await api_base.put(`/api/v1/notifications/${id}/read`);
  return response.data;
};

export const deleteNotification = async (id: string): Promise<void> => {
  await api_base.delete(`/api/v1/notifications/${id}`);
};

export const deleteAllNotifications = async (): Promise<void> => {
  await api_base.delete("/api/v1/notifications/delete-all");
};
